import React from 'react';

import { FellesKvittering } from './klage-kvittering';

export const SignertFullmakt = () => {
    return (
        <FellesKvittering
            successMelding="Fullmakten er signert!"
            content={<p>Takk! Vi sender en e-post med bekreftelse på at fullmakten er signert.</p>}
        />
    );
};
